<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-data-table :headers='headers' :items='itens' class='elevation-1' :search="search" :items-per-page="itemsPerPage" @update:items-per-page=" v => itemsPerPage = v">
          <template v-slot:top>
            <v-toolbar flat color='white'>
              <v-toolbar-title v-text="$t('keywords.listing')" />
              <v-divider class='mx-4' inset vertical></v-divider>
              <v-btn color='primary' dark class='mb-2' @click="deprecationAlert">{{ $t('button.new') }}</v-btn>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-toolbar flat color='white'>
            <v-row>
              <SearchField v-model="clienteNameSearch" :label="$t('client.search.client')" />
              <SearchField v-model="urlPrefixSearch" :label="$t('client.search.url_prefix')" />
            </v-row>
          </v-toolbar>
          </template>
          <template v-slot:item.lastModified='{ item }'>
            <LastModify :date="item.lastModified" :by="item.lastModifiedBy"/>
          </template>
          <template v-slot:item.actions='{ item }'>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="green" small class='mr-2' @click='goToSelectClient(item.urlPrefix)'>mdi-list-box-outline</v-icon>
              </template>
              <span>{{$t('client.listing')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="orange" small class='mr-2' @click='editItem(item)'>mdi-pencil</v-icon>
              </template>
              <span>{{$t('button.edit')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="red" small class='mr-2' @click='deleteItem(item)'>mdi-delete</v-icon>
              </template>
              <span>{{ $t('button.delete') }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.platform='{ item }'>
            <v-icon color="primary" v-if="item.platform">mdi-check-circle</v-icon>
            <v-icon color="red" v-else>mdi-close-circle</v-icon>
          </template>
          <template v-slot:item.active='{ item }'>
            <v-icon color="primary" v-if="item.active">mdi-check-circle</v-icon>
            <v-icon color="red" v-else>mdi-close-circle</v-icon>
          </template>
          <template v-slot:no-data>
            {{ $t('warnings.no_data_found') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/ClientService'
import IncludesIgnoreCase from '../../utils/IncludesIgnoreCase'
import LastModify from '../core/LastModify.vue'
import SearchField from '../core/SearchField.vue'

export default {
  name: 'clientGrid',
  data: () => ({
    search: '',
    clienteNameSearch: '',
    urlPrefixSearch: '',
    itens: []
  }),
  computed: {
    version () { return this.$versionable.versions.clients },
    itemsPerPage: {
      get () {
        return this.$cookies.isKey('client_per_page') ? parseInt(this.$cookies.get('client_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('client_per_page', value)
      }
    },
    headers () {
      return [
        {
          text: this.$t('client.name'),
          value: 'clientName',
          sortable: false,
          align: 'start',
          filter: clientName => IncludesIgnoreCase(clientName, this.clienteNameSearch)
        },
        {
          text: this.$t('keywords.last_modify'),
          value: 'lastModified',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('client.url.prefix'),
          value: 'urlPrefix',
          sortable: false,
          align: 'start',
          filter: urlPrefix => IncludesIgnoreCase(urlPrefix, this.urlPrefixSearch)
        },
        {
          text: this.$t('client.platform'),
          value: 'platform',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('check.active'),
          value: 'active',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('keywords.actions'),
          value: 'actions',
          sortable: false
        }
      ].filter(h => h.show ?? true)
    }
  },
  mounted () {
    this.searchAll()
  },
  methods: {
    searchAll () {
      Servico.findAll()
        .then((result) => {
          this.itens = result.data
        })
    },
    editItem (item) {
      this.$emit('editItem', false, item)
    },
    deleteItem (item) {
      if (confirm(this.$t('warnings.confirm.delete'))) {
        Servico.delete(item)
          .then((result) => {
            this.searchAll()
          })
          .catch((error) => {
            console.error(`${this.$t('warnings.error.delete')} : ${error}`)
          })
      }
    },
    goToSelectClient (urlPrefix) {
      this.$router.push('/select-client?from=' + urlPrefix)
    },
    deprecationAlert () {
      alert(this.$t('client.deprecation_alert'))
    }
  },
  components: { LastModify, SearchField }
}
</script>
